// controllers/refresh_on_close_controller.js
import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = {
    url: String // Optional override
  }

  connect() {
    this.element.addEventListener("dialog:closed", this.handleDialogClosed)
  }

  disconnect() {
    this.element.removeEventListener("dialog:closed", this.handleDialogClosed)
  }

  handleDialogClosed = () => {
    const url = this.urlValue || window.location.pathname

    get(url, {
      responseKind: "turbo-stream"
    });
  }
}

/*


<div data-controller="refresh-on-close">
  <%= modal("my-modal-frame") %>
</div>

<div data-controller="refresh-on-close"
     data-refresh-on-close-url-value="<%= article_path(@article) %>">
  <%= modal("article-modal") %>
</div>

*/


